import React from 'react'
import styled from 'styled-components'
import { Body } from 'src/Styles/text-styles'
import BulletPoints from 'src/SpeedTestDetail/RecommendationView/RecommendationBulletPoint'
import { localize } from 'src/lib/localize'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const BoldBody = styled(Body)`
  font-weight: 600;
  padding-right: 8px;
  padding-left: 16px;
  line-height: 28px;
  letter-spacing: 0.5px;
`

const Title = localize('TITLE')(
  'General speed recommendations for the best experience:'
)
const DownloadTitle = localize('LABEL')('Download:')
const UploadTitle = localize('LABEL')('Upload:')
const HunderPlusMBPS = localize('LABEL')('100+ Mbps:')
const HunderPlusMBPSDownloadDescription = localize('LABEL')(
  'Gaming, 4K video streaming, System software updates (5GB)'
)
const HunderPlusMBPSUploadDescription = localize('LABEL')(
  'Large file transfers to cloud storage (2.5GB+)'
)

const FiftyPlusMBPS = localize('LABEL')('50+ Mbps:')
const FiftyPlusMBPSDownloadDescription = localize('LABEL')('Video chat')
const FiftyPlusMBPSUploadDescription = localize('LABEL')(
  '5 minutes of 4K video'
)

const TwentyFivePlusMBPS = localize('LABEL')('25+ Mbps:')
const TwentyFivePlusMBPSDownloadDescription = localize('LABEL')(
  '1080p video streaming, Large images (3MB)s'
)
const TwentyFivePlusMBPSUploadDescription = localize('LABEL')(
  '5 minutes of 1080p video, Gaming, Large images'
)

const FivePlusMBPS = localize('LABEL')('5+ Mbps:')
const FivePlusMBPSDownloadDescription = localize('LABEL')(
  'Streaming music, General web browsing, Medium size images (1MB)'
)
const FivePlusMBPSUploadDescription = localize('LABEL')('Medium sized images')

export default () => {
  return (
    <Container>
      <BoldBody style={{ paddingLeft: 0, marginTop: '16px' }}>{Title}</BoldBody>
      <DownloadRecoomedationView />
      <UploadRecoomedationView />
    </Container>
  )
}

const DownloadRecoomedationView = () => {
  return (
    <div>
      <BoldBody style={{ paddingLeft: 0 }}>{DownloadTitle}</BoldBody>

      <BulletPoints
        speed={HunderPlusMBPS}
        speedDescription={HunderPlusMBPSDownloadDescription}
      />

      <BulletPoints
        speed={FiftyPlusMBPS}
        speedDescription={FiftyPlusMBPSDownloadDescription}
      />

      <BulletPoints
        speed={TwentyFivePlusMBPS}
        speedDescription={TwentyFivePlusMBPSDownloadDescription}
      />
      <BulletPoints
        speed={FivePlusMBPS}
        speedDescription={FivePlusMBPSDownloadDescription}
      />
    </div>
  )
}

const UploadRecoomedationView = () => {
  return (
    <div>
      <BoldBody style={{ paddingLeft: 0, marginTop: '16px' }}>
        {UploadTitle}
      </BoldBody>

      <BulletPoints
        speed={HunderPlusMBPS}
        speedDescription={HunderPlusMBPSUploadDescription}
      />

      <BulletPoints
        speed={FiftyPlusMBPS}
        speedDescription={FiftyPlusMBPSUploadDescription}
      />

      <BulletPoints
        speed={TwentyFivePlusMBPS}
        speedDescription={TwentyFivePlusMBPSUploadDescription}
      />
      <BulletPoints
        speed={FivePlusMBPS}
        speedDescription={FivePlusMBPSUploadDescription}
      />
    </div>
  )
}
